import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import Loader from './../shared/loader'
import CryptoJS from 'crypto-js'
import download from 'downloadjs'
import Pagination from './../shared/pagination'
// import csvHelper from '../importjsontocsv';
import Vue from "vue";
import JsonExcel from "vue-json-excel";
import { BasicSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
Vue.component("downloadExcel", JsonExcel);
export default {
	name: 'detailedrackauditreport',
	components: {
		Paginate,
		Pagination,
		DatePicker,
		JsonExcel,
		Loader,
		BasicSelect
	},
	data() {
		return {
			activeButton: null,
			reportname: '',
			csvFieldsForXls: {},
			listStockReportDataforxls: [],
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			// currentPage: 0,
			listAuditData: [],
			listAuditDatacsv: [],
			displayMsg: false,
			successErrorMsg: "",
			fromDateFlt: "",
			toDateFlt: "",
			// totalPage: 0,
			// pageNo: 0,
			listClientData: [],
			listWarehouseData: [],
			clientid: '',
			client: '',
			warehouseid: '',
			warehouse: '',
			ClientErr: '',
			WarehouseErr: '',
			searchFlag: false,
			showSelectWarehouse: false,
			showSelectClient: false,
			loginuserid: '',
			isLoading: false,
			// perPage: 10,
			formattedDate: '',
			user_type: '',
			productid: '',
			rackid: '',
			resultCount: 0,
			userid: '',
			show: false,
			download: true,
			dataFilter2: '',
			isLoadingforxls: false,
			limitExeed: false,
			recordLimit: 0,
			listMerchantIdData: [],
			merchantnameFlt: '',
			merchant: '',
			item: {},
			listMerchantData1: [],
			merchantList: [],
			opened: [],
			contentVisible:false,
			toCheckShowRowIndex:'',
			selectassign:'',
			popupOpen:false,
			totalopenRows:0,
			totalcloseRows:0,
			isuserAssigned:false,
			Shortdata:[],
			excessData:[],
			Extradata:[],
			nfCyclecountId:'',
			nfCyclecountCreatedDate:'',
			nfCyclecountCompletedDate:'',
			nfCyclecountCompletedBy:'',
			Assignedto:'',
			skuid:'',
			rackid:'',
			allocationtime:'',
			nfCyclecountCompletedBy:'',
			nfeancode:'',
			nfrackid:'',
			currentTaskid:'',
			pickerListData:'',
			pickeruser:'',
			disableassign:true,
			tasksessionid:'',
			nfActivityId:'',
			usermail:'',
			disableviewvariance:false,
			allocationtimeNf:'',
			currenttype:''
		}
	},
	filters: {
		moment: function (dates) {
			return moment(dates).format('DD-MM-YYYY HH:mm:ss');
		}
	},
	mounted() {
		this.calldateFunction()
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.userid = userdetail.userid;
		this.loginuserid = userdetail.userid;
		this.user_type = userdetail.utype;
		this.pageNo = 0;
		this.reportname = this.$t('editedjson.rackAuditReportDetailed');
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if (localStorage.getItem("selectedWarehouse")!='undefined' && localStorage.getItem("selectedClient")!='undefined')
		{
		this.getMerchantData();

		}
		this.$root.$on('localStorageChanged', (newValue) => {
			// Update your local data
			this.warehouse = newValue;
			// console.log(newValue+"===============in event")
			// Perform any other actions needed
			this.getPickersList();
		  });
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.getMerchantData();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();
				this.getPickersList()

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;
			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
		this.getRecordLimit()

	}, // End computed
	methods: {
		calldateFunction: function () {
			this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
			this.toDateFlt = this.currentDate;
			var dt = new Date(this.currentDate);
			dt.setDate(dt.getDate() - 6);
			this.fromDateFlt = dt;
		},
		assignedUser(){
			this.isuserAssigned = true
		},
		getMerchantData() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: this.clientid,
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'merchantList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listMerchantData = result.data;
						this.item = {
							value: '',
							text: ''
						};
						this.listMerchantData1 = [{ value: '', text: this.$t('common.selectMerchantPlaceHolder') }];
						this.listMerchantData.forEach(ele => {
							this.listMerchantData1.push({
								"value": ele.merchantid,
								"text": ele.merchantname
							})
						})
					}
				}, error => {
					console.error(error)
				})
		},

		reset() {
			this.item = {}
		},
		onSelect(item) {
			this.item = item
			this.merchantnameFlt = item.value
		},
		getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({

			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getRecordLimit',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;


					}
				}, error => {
					console.error(error)
				})
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getAuditListForXLS(3)


			}
		},
		export(data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		},
		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
				type: mime
			})
		},
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
		dateFormat1(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 00:00:00";
		},
		dateFormat2(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 23:59:59";
		},
		// getClientList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		if (this.warehouseid)
		// 			this.input = ({
		// 				warehouseid: this.warehouseid,
		// 			});
		// 		else {
		// 			this.input = {};
		// 		}

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },

		// getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 			.then(result => {
		// 				// console.log(result.data.data);
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },
		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;
		// 		this.merchantnameFlt = '';
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = []
		// 			this.getWarehouseList();
		// 			this.getMerchantData();
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {
		// 			if (this.warehouseid && this.clientid) {
		// 				this.getMerchantData();

		// 				//this.getAuditList();
		// 			}
		// 		}
		// 	}
		// 	this.listAuditData = [];
		// 	this.pageno = this.totalPage = 0;
		// },

		showRow(data){
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			this.isLoading = true;
			this.contentVisible = true;
			this.isuserAssigned = false;
			this.pickeruser = ''
			data.contentVisible = data.contentVisible == true ? false : true;
			this.toCheckShowRowIndex = Number(this.listAuditData.indexOf(data))
			for (var i = 0; i < this.listAuditData.length; i++) {
				if (this.listAuditData[i].contentVisible == true && i != this.toCheckShowRowIndex) {
					this.listAuditData[i].contentVisible = false
				}
			}
			const index = this.opened.indexOf(data.rackid);
			if (index > -1) {
				this.opened.splice(index, 1)
			} else {
				this.opened = []
				this.opened.push(data.rackid)
			}

			if (window.localStorage.getItem("selectedClient") == '') {
				this.ClientErr = this.$t('common.clientError');
				this.isLoading = false;
				return false
			}
			axios({
				method: 'GET',
				'url': `${apiUrl.api_url}nfitems/${data.id}`,
				headers: {
					'Authorization': 'Bearer ' + myStr,
					'xbclientid': window.localStorage.getItem("selectedClient")
				}
			}).then(res=>{
				this.isLoading = false;
				this.nfCyclecountId = res.data.data.taskdetails.taskid
				this.nfActivityId = res.data.data.taskdetails.activitydetailsid
				this.nfCyclecountCreatedDate = res.data.data.taskdetails.createddate
				this.nfCyclecountCompletedDate =res.data.data.taskdetails.taskstatus === "done" && res.data.data.rackauditdetails.endtime
				this.nfCyclecountCompletedBy = res.data.data.taskdetails.taskstatus === "done" && res.data.data.taskdetails.assignedto
				this.Assignedto = res.data.data.taskdetails.assignedto
                this.allocationtimeNf = res.data.data.destrackdetails.lastmodifieddate
				this.nfeancode =res.data.data.eancode
				this.nfrackid = res.data.data.destrackdetails.rackid
				this.tasksessionid = res.data.data.rackauditdetails.sessionid
				this.disableviewvariance = res.data.data.taskdetails.taskstatus === "done" && this.tasksessionid ? false : true
			})
		},
		getTabTitle(key,data) {
			const excessMessage = `${this.$t(`importCsv.${key}`)} (${data.length})`;
			return excessMessage;
								  },
		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.totalPage = 0;
		// 	if (this.warehouseid) {
		// 		this.getPickersList()
		// 		if (this.clientid) {

		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },

		notfoundListingsearch(type){
			this.currentPage = 1;
			this.currenttype = type
			if (type === 'open') {
				document.getElementById('openbtn').style.backgroundColor = 'grey'; // Change to your desired background color
				document.getElementById('openbtn').style.color = 'white'; // Change to your desired text color
				document.getElementById('closebtn').style.backgroundColor = '';
				document.getElementById('closebtn').style.color = '';
			  } else if (type === 'closed') {
				document.getElementById('closebtn').style.backgroundColor = 'grey'; // Change to your desired background color
				document.getElementById('closebtn').style.color = 'white'; // Change to your desired text color
				document.getElementById('openbtn').style.backgroundColor = '';
				document.getElementById('openbtn').style.color = '';
			  }	else if (!type){
				document.getElementById('openbtn').style.backgroundColor = '';
				document.getElementById('openbtn').style.color = '';
				document.getElementById('closebtn').style.backgroundColor = '';
				document.getElementById('closebtn').style.color = '';
			  }
			  this.notfoundListing(type)
		},
		dateFormat(date, type) {
			if (!date) return '';

			if (type == 1) {
				return moment(date).format('YYYY-MM-DD 00:00:00');
			} else {
				return moment(date).format('YYYY-MM-DD 23:59:00');
			}
		},
		notfoundListing(type) {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			this.isLoading = true;

			let params = {
				offset: (this.currentPage - 1) * 10,
				limit: 10,
			};
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				this.isLoading = false;
				return false
			}
			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.isLoading = false;
				return false
			}
			if (window.localStorage.getItem("selectedWarehouse")) {
				params.warehouseid = window.localStorage.getItem("selectedWarehouse");
			}

			if (this.fromDateFlt) {
				params.fromdate = this.dateFormat(this.fromDateFlt, 1);;
			}

			if (this.toDateFlt) {
				params.todate = this.dateFormat(this.toDateFlt, 2);
			}
			if (this.productid) {
				params.eancodes = this.productid;
			}

			if (this.rackid) {
				params.rackids = this.rackid
			}

			if(type){
				params.taskstatus = type
			}
			if(!type && this.currenttype){
				params.taskstatus = this.currenttype
			}
			axios({
				method: 'GET',
				'url': `${apiUrl.api_url}nfitems`,
				params: params,
				headers: {
					'Authorization': 'Bearer ' + myStr,
					'xbclientid': localStorage.getItem("selectedClient")
				}
			})

				.then(result => {
					this.listAuditData = result.data.data;

					this.resultCount = this.listAuditData.length
					if (result.data.errorCode == -1) {
						this.resultCount = 0;
						this.totalRows = 0;
						this.$alertify.error(result.data.msg);
					} else {
						this.totalRows = result.data.summary.totalCount
						this.totalopenRows=result.data.summary.openCount
						this.totalcloseRows=result.data.summary.closedCount

						console.log(type,"========type===========");
						if(type =='open'){
							this.totalRows = result.data.summary.openCount
						}else if(type =='closed'){
							this.totalRows = result.data.summary.closedCount
						}

						if (Number(this.totalRows) > Number(this.recordLimit)) {
							this.limitExeed = true
						}

						if (this.totalRows == 0) {
							this.totalPage = 0
						} else if (this.totalRows < 10) {
							this.totalPage = 1
						} else {
							this.totalPage = Math.ceil(this.totalRows / 10)
						}
					}

					this.isLoading = false;
				}, error => {
					console.error(error);
				})
		},
		getPickersList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			if (localStorage.getItem("selectedWarehouse") == '') {
				this.ClientErr = this.$t('common.warehouseError');
				return false;
			}
			this.input = ({
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
			});
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getWarehousePickerList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					this.pickerListData = result.data.data.data;
				}, error => {
					console.error(error)
				})
		},
		assignedUserNf() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			if (!this.pickeruser) {
				this.$alertify.error("Please select User")
			}
			if (this.pickeruser) {
				let userdata = this.pickerListData.filter(obj => obj.userid == this.pickeruser);
				this.usermail = userdata[0].email
			}
			let payload = {
				assignedto: this.usermail,
				userid: this.pickeruser
			}
			axios({
				method: 'PUT',
				'url': `${apiUrl.api_url}tasks/${this.nfCyclecountId}`,
				'data': payload,
				headers: {
					'Authorization': 'Bearer ' + myStr,
					'xbclientid': localStorage.getItem("selectedClient")
				}
			})
				.then(result => {
					if (!result.data.errorCode) {
						this.isuserAssigned = true;
						this.nfCyclecountCompletedBy = this.usermail
						this.$alertify.success(result.data.msg)
						this.notfoundListingsearch()

					}
				})
		},
		getVariance(data) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.popupOpen = true

			this.input = ({
				warehouseid: window.localStorage.getItem("warehouseSelected"),
				clientid: window.localStorage.getItem("selectedClient"),
				rackid: data.rackid,
				userid: this.userid,
				sessionid:this.tasksessionid ? this.tasksessionid : -1
			});
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getRackAuditReport',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					console.log(result.data.data.data,"===========result.data.data.data======");
						if (Object.keys(result.data.data.data).length > 0) {
						   this.excessData = result.data.data.data.excessQty
						   this.Shortdata = result.data.data.data.shortProdQty
						   this.Extradata = result.data.data.data.excessProd

						} else {
								this.$alertify.error(this.$t('apiErrors.INVALID_SESSION_RACKID'));
								this.popupOpen = false
						}
				}, error => {
					console.error(error);
				})
		},
		// getPaginationData(currentPage) {
		// 	this.pageNo = (currentPage - 1) * this.perPage;
		// 	this.getAuditList()
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.notfoundListing()
		},
		AuditListing() {
			this.currentPage = 1;
			this.totalPage = 0;
			this.resultCount = 0;
			this.searchFlag = true;
			this.getAuditList(2);
		},
		resetAuditSerach() {
			this.show = false;
			this.download = true;
			this.fromDateFlt = "";
			this.toDateFlt = "";
			this.listAuditData = [];
			this.pageNo = 0;
			this.clientid = '';
			this.totalPage = 0;
			this.resultCount = 0;
			this.totalRows = 0;
			this.searchFlag = false;
			this.rackid = '';
			this.productid = '';
			this.disableassign = true
			this.totalopenRows = 0
			this.totalcloseRows = 0
			this.disableviewvariance = false
			if (this.user_type == 'warehouse_user')
				this.client = '';
			else if (this.user_type == 'client_user')
				this.warehouse = '';
			else {
				this.client = '';
				this.warehouse = '';
			}
			// this.getAuditList();
		},
		onSubmit: function () {
			this.$validator.validateAll().then(() => {
				console.log('form is valid', this.model)
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		},
	} // end methods

}



// WEBPACK FOOTER //
// ./src/views/components/notfound/NotFound.component.js